// Prévia do total no Pix e no boleto para o carrinho e o mini carrinho
// (2026-10-25). Só exibição: o valor que vale é o do checkout, calculado no
// banco (native_payment_discount_bps: Pix 10%, boleto 5%, sobre os produtos;
// o frete entra cheio). Com cupom aplicado não há prévia -- o modo do cupom
// (cumulativo ou não) muda a conta e quem decide é o checkout.

import { PIX_DISCOUNT_RATE, BOLETO_DISCOUNT_RATE } from "./paymentDiscount.ts";

export const PIX_DISCOUNT_BPS = Math.round(PIX_DISCOUNT_RATE * 10000);
export const BOLETO_DISCOUNT_BPS = Math.round(BOLETO_DISCOUNT_RATE * 10000);

export interface PaymentPreviewLine {
  totalMinor: number;
  savingsMinor: number;
}

export interface CartPaymentPreview {
  pix: PaymentPreviewLine;
  boleto: PaymentPreviewLine;
}

/** Mesmo arredondamento do checkout (meio centavo para cima). */
export function discountMinor(baseMinor: number, bps: number): number {
  return Math.floor((Math.max(0, Math.trunc(baseMinor)) * bps + 5000) / 10000);
}

/**
 * @param itemsMinor  soma dos produtos (centavos)
 * @param totalMinor  total cheio que o cliente vê hoje (produtos + frete, se calculado)
 * @param hasCoupon   cupom aplicado no carrinho: sem prévia
 */
export function computeCartPaymentPreview(input: {
  itemsMinor: number;
  totalMinor: number;
  hasCoupon: boolean;
}): CartPaymentPreview | null {
  if (input.hasCoupon) return null;
  const items = Math.max(0, Math.trunc(input.itemsMinor));
  const total = Math.max(items, Math.trunc(input.totalMinor));
  if (items <= 0) return null;
  const line = (bps: number): PaymentPreviewLine => {
    const savingsMinor = discountMinor(items, bps);
    return { savingsMinor, totalMinor: total - savingsMinor };
  };
  return { pix: line(PIX_DISCOUNT_BPS), boleto: line(BOLETO_DISCOUNT_BPS) };
}
